import styled from "@emotion/styled";

import { FormattedMessage, type FormatMessages } from "@skilitics/localization";

const Container = styled.div`
  display: flex;

  width: 100%;

  padding-block: 15px;

  font-style: italic;

  user-select: none;
`;

type Props = {
  count: number;
  querying: boolean;
  libraryLabel: string;
};

export const Results = ({ count, querying, libraryLabel }: Props) => (
  <Container data-test="results-container">
    <FormattedMessage
      messages={querying ? formatStrings.querying : formatStrings.result}
      values={{ count, libraryLabel }}
    />
  </Container>
);

const formatStrings = {
  result: {
    en: "There {count, plural, =1 {is 1 result that matches} other {are # results that match}} your query...",
  },
  querying: {
    en: "Searching {libraryLabel} library...",
  },
} satisfies FormatMessages;
